<template>
  <div class="value-meter" :style="cssVars">
    <div class="filled-bar"></div>
    <div class="label">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import ValueRange from '@/effects/ValueRange'

@Options({
  props: {
    container: ValueRange,
    barColor: String,
    backgroundColor: String
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    cssVars() {
      return {
        '--percent-filled': this.container.fraction * 100 + '%',
        '--background-color': this.backgroundColor,
        '--bar-color': this.barColor
      }
    }
  }
})
export default class ValueMeter extends Vue {
  container!: ValueRange | undefined
  backgroundColor: string = '#282c3b'
  barColor: string = '#741A32'
}
</script>

<style scoped lang="scss">
  .value-meter {
    border: 1px solid black;
    border-radius: 0;
    background-color: var(--background-color);
    position: relative;
    height: 1em;
  }

  .filled-bar {
    height: 100%;
    transition: width 0.1s linear;

    border-radius: 0;
    background-color: var(--bar-color);
    width: var(--percent-filled);
  }

  .label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    display: grid;
    place-items: center;
  }

</style>
